import { t, Instance } from 'mobx-state-tree';

/**
 * Manages the parents of the tree anchor from HybridPedigreeStore
 */
export const ParentsGenerationModel = t
  .model('ParentsGeneration', {
    leftParentFamilyMemberId: t.maybeNull(t.string),
    rightParentFamilyMemberId: t.maybeNull(t.string)
  })
  .actions((self) => ({
    setLeftParentFamilyMemberId(leftParentFamilyMemberId: string | null) {
      self.leftParentFamilyMemberId = leftParentFamilyMemberId;
    },

    setRightParentFamilyMemberId(rightParentFamilyMemberId: string | null) {
      self.rightParentFamilyMemberId = rightParentFamilyMemberId;
    },

    clear() {
      self.leftParentFamilyMemberId = null;
      self.rightParentFamilyMemberId = null;
    }
  }));

export type ParentsGenerationType = Instance<typeof ParentsGenerationModel>;
